<template lang="pug">
form.regular-form-style
  slot
</template>

<script lang="ts">
import Vue from "vue";
import {Component} from "vue-property-decorator";

@Component({
  name: "RegularFormStyle"
})
export default class RegularFormStyle extends Vue {

}
</script>

<style scoped lang="less">
form.regular-form-style {
  ::v-deep {
    .form-group {
      display: grid;
      grid-gap: 0 35px;
      grid-template-columns: repeat(12, [col-start] 1fr);// [labels] 30% [controls] 370px auto;
      grid-auto-flow: row;
      grid-auto-rows: auto;
      //margin-left: 20px;
      //margin-right: 20px;
      //width: 100%;
      justify-content: left;

      .help-block {
        font-size: 95%;
      }

      .form-control {
        width: 100%;
      }
      .input-controls {
        grid-column: col-start 5 / span 6;

      }

      + .form-group {
        margin-top: 15px;
      }

      .label-control {
        text-align: right;
        height: 48px;
        align-items: center;
        label {
          font-weight: normal;
        }
        display: grid;
        //grid-area: labels;
        grid-column: col-start 1 / span 4;
      }
    }

    label, .control-label {
      margin: 0;
      position: relative;


      &.required {
        &:after {
          color: #ee4538;
          content: "*";
          position: absolute;
          right: -7px;
          top: 0;
        }
      }
    }
  }
}
</style>
